import React from "react";

export default function FeaturesTable() {
  return (
    <div className="mx-4">
      <div className="overflow-x-auto rounded-2xl shadow ring-1 ring-gray-200 bg-white w-full max-w-screen-xl">
        <div className="min-w-full">
          {/**
           * Bảng được trang trí lại:
           * - Viền cho từng ô (border cell)
           * - Header sticky, nền xanh (theme-blue)
           * - Zebra striping cho các dòng chẵn
           * - Hover highlight toàn dòng
           * - Sử dụng arbitrary variants Tailwind để tránh phải chỉnh tay từng <td>
           */}
          <table
            className="min-w-full table-auto border border-gray-300 overflow-hidden rounded-lg
              [&_th]:bg-theme-blue [&_th]:text-white [&_th]:font-semibold [&_th]:uppercase [&_th]:text-xs [&_th]:tracking-wide [&_th]:px-4 [&_th]:py-3
              [&_td]:align-top [&_td]:px-4 [&_td]:py-2 [&_td]:text-sm [&_td]:border [&_td]:border-gray-200 [&_td]:leading-relaxed
              [&_tbody_tr:nth-child(even)_td]:bg-gray-50
              [&_tbody_tr:hover_td]:bg-blue-50 transition-colors"
          >
            <thead className="sticky top-0 shadow-sm z-10">
              <tr>
                <th className="w-14">STT</th>
                <th>Tên tính năng</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td />
                <td className="font-bold">Ứng dụng WEB</td>
              </tr>
              <tr>
                <td className="font-bold">A</td>
                <td className="font-bold">Phân hệ Đại hội, hội nghị</td>
              </tr>
              <tr>
                <td className="font-bold">I</td>
                <td className="font-bold">
                  Quản lý Thông tin Đại hội, hội nghị
                </td>
              </tr>
              <tr>
                <td>1</td>
                <td>Quản lý Danh mục nhiệm kỳ</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa nhiệm kỳ</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách nhiệm kỳ theo tiêu chí Tên nhiệm kỳ, Ngày
                  bắt đầu, Ngày kết thúc
                </td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm nhiệm kỳ theo tiêu chí (Tên nhiệm kỳ)</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Quản lý kỳ họp, kỳ Đại hội, Hội nghị</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa kỳ họp, Đại hội, Hội nghị</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp kỳ họp,Đại hội, Hội nghị theo tiêu chí (Tên kỳ họp,
                  Ngày bắt đầu, Ngày kết thúc, Loại kỳ họp)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Tìm kiếm kỳ họp, Đại hội, Hội nghị theo tiêu chí (tên, từ ngày
                  đến ngày tháng năm, loại)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Kích hoạt để hiện trên các giao diện người dùng mặc định (theo
                  1 link sẵn có, hoặc mobile app default)
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>
                  Quản lý phiên họp (hoặc nội dung, tùy theo mức độ quy mô của
                  kỳ họp)
                </td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm phiên họp theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách theo các tiêu chí (ngày giờ bắt đầu, kết
                  thúc, tổng thời lượng, buổi)
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa phiên họp</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Quản lý Danh mục Loại Họp, Đại hội, Hội nghị</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa Loại Họp, Đại hội, Hội nghị</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Quản lý Chương trình</td>
              </tr>
              <tr>
                <td />
                <td>
                  Tìm kiếm thông tin chương trình đại hội theo các tiêu chí
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách theo các tiêu chí (thời gian, kỳ họp, người
                  chủ trì)
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa chương trình đại hội</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Quản lý Thông báo</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm thông báo đại hội theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí (thời gian, kỳ họp)</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa thông báo đại hội</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Quản lý Thông cáo báo chí</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm thông cáo báo chí theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí (thời gian, kỳ họp)</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sưa/xóa thông cáo báo chí</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Thống kê số lượng Kỳ họp</td>
              </tr>
              <tr>
                <td />
                <td>
                  Thống kê số lượt đại biểu tham dự với tiêu chí mặc định và các
                  tiêu chí tùy chọn
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Biểu đồ trực quan số lượng Kỳ họp theo thời gian, nhiệm kỳ
                </td>
              </tr>
              <tr>
                <td>9</td>
                <td>Thống kê số lượt đại biểu tham dự</td>
              </tr>
              <tr>
                <td>10</td>
                <td>
                  Thống kê số lượng phiên họp (là nội dung) bị hủy, bị trễ
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Thống kê số lượng phiên họp với tiêu chí mặc định và các tiêu
                  chí tùy chọn
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Biểu đồ trực quan số lượt phiên họp (là nội dung) bị hủy theo
                  thời gian, nhiệm kỳ
                </td>
              </tr>
              <tr>
                <td className="font-bold">II</td>
                <td className="font-bold">Xem Thông tin Đại hội, hội nghị</td>
              </tr>
              <tr>
                <td>11</td>
                <td>
                  Xem Thông tin Chương trình, thông báo, thông báo báo chí của
                  Đại hội, hội nghị
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn ngày diễn ra Đại hội, hội nghị và xem danh sách chương
                  trình, thông báo, thông cáo báo chí Đại hội, hội nghị, thông
                  báo
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn xem chi tiết thông tin chương trình Đại hội, hội nghị
                </td>
              </tr>
              <tr>
                <td />
                <td>Chọn xem chi tiết thông báo Đại hội, hội nghị</td>
              </tr>
              <tr>
                <td />
                <td>Chọn xem chi tiết Thông cáo báo chí</td>
              </tr>
              <tr>
                <td>12</td>
                <td>
                  Xuất dữ liệu database không mật để import vào hệ thống
                  Internet
                </td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm dữ liệu</td>
              </tr>
              <tr>
                <td />
                <td>Xuất dữ liệu</td>
              </tr>
              <tr>
                <td className="font-bold">B</td>
                <td className="font-bold">Phân hệ Nhân sự</td>
              </tr>
              <tr>
                <td className="font-bold">I</td>
                <td className="font-bold">Quản lý người dùng</td>
              </tr>
              <tr>
                <td>13</td>
                <td>Quản lý danh mục Cơ quan, đơn vị, tổ chức</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm Cơ quan, đơn vị, tổ chức theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa Cơ quan, đơn vị, tổ chức</td>
              </tr>
              <tr>
                <td>14</td>
                <td>Quản lý danh mục Chức vụ (dùng gợi nhớ khi gõ)</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm chức vụ theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa chức vụ</td>
              </tr>
              <tr>
                <td>15</td>
                <td>Quản lý danh mục Dân tộc</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm dân tộc theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa dân tộc</td>
              </tr>
              <tr>
                <td>16</td>
                <td>Quản lý danh mục Tôn giáo</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm tôn giáo theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa tôn giáo</td>
              </tr>
              <tr>
                <td>17</td>
                <td>Quản lý danh mục Học hàm</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm học hàm theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa học hàm</td>
              </tr>
              <tr>
                <td>18</td>
                <td>Quản lý danh mục Học vị</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm học vị theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa học vị</td>
              </tr>
              <tr>
                <td>19</td>
                <td>Quản lý danh bạ Đại biểu/ Khách mời</td>
              </tr>
              <tr>
                <td />
                <td>
                  Tìm kiếm đại biểu, khách mời theo các tiêu chí (ID đại biểu,
                  họ tên, giới tính,…)
                </td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa thông tin đại biểu, khách mời</td>
              </tr>
              <tr>
                <td />
                <td>
                  Kết nối đến phần mềm thứ 3 để lấy thông tin mật của đại biểu
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Import danh bạ đại biểu, khách mời (Cho phép cập nhật những
                  đại biểu có sẵn dựa trên mã ID, không phải xóa hết cập nhật
                  mới)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Export danh bạ đại biểu, khách mời ra file Excel, Word, Ldif
                </td>
              </tr>
              <tr>
                <td />
                <td>Cho các ứng dụng khác truy xuất dữ liệu.</td>
              </tr>
              <tr>
                <td>20</td>
                <td>
                  Quản lý danh sách Đại biểu/Khách mời theo kỳ Đại hội, hội nghị
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Tìm kiếm đại biểu, khách mời theo các tiêu chí (tên, chức vụ,
                  sdt, email, cơ quan công tác, dự khuyết ...)
                </td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sửa/xóa thông tin đại biểu, khách mời</td>
              </tr>
              <tr>
                <td />
                <td>Copy danh sách qua kỳ đại hội khác</td>
              </tr>
              <tr>
                <td />
                <td>
                  Tạo một bản sao danh sách riêng cho Kỳ Đại hội, hội nghị
                </td>
              </tr>
              <tr>
                <td />
                <td>Lựa chọn sao chép danh sách qua kỳ đại hội khác</td>
              </tr>
              <tr>
                <td />
                <td>
                  Cập nhật thông tin điểm danh cụ thể (ai, chức vụ, đơn vị) cho
                  Khách mời đại diện
                </td>
              </tr>
              <tr>
                <td />
                <td>Import danh sách đại biểu, khách mời</td>
              </tr>
              <tr>
                <td />
                <td>
                  Export danh sách đại biểu, khách mời ra file Excel, Word, Ldif
                </td>
              </tr>
              <tr>
                <td>21</td>
                <td>Quản lý khách mời đại diện</td>
              </tr>
              <tr>
                <td />
                <td>
                  Tìm kiếm khách mời đại diện theo các tiêu chí (ID khách mời,
                  Đơn vị,…)
                </td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa thông tin khách mời đại diện</td>
              </tr>
              <tr>
                <td />
                <td>Lựa chọn sao chép thành danh bạ khác</td>
              </tr>
              <tr>
                <td />
                <td>
                  Export danh sách khách mời đại diện ra file Excel, Word, Pdf
                </td>
              </tr>
              <tr>
                <td>22</td>
                <td>
                  Quản lý danh mục Đoàn Đại biểu (Đoàn khác cơ quan đơn vị tổ
                  chức)
                </td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm đoàn đại biểu theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa thông tin đoàn đại biểu</td>
              </tr>
              <tr>
                <td />
                <td>Lựa chọn trạng thái (active/inactive) cho đoàn đại biểu</td>
              </tr>
              <tr>
                <td />
                <td>
                  Giao diện kéo thả, sắp xếp, chọn nhiều đại biểu vào đơn vị và
                  giao diện chọn đơn vị cho đại biểu (có kéo thả theo thứ tự, 1
                  đại biểu 1 Đoàn)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Lựa chọn sắp xếp danh sách đơn vị mặc định theo alphabet, hoặc
                  theo thứ tự được cung cấp.
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Lựa chọn sắp xếp danh sách đại biểu của đơn vị mặc định theo
                  alphabet, hoặc theo thứ tự được cung cấp.
                </td>
              </tr>
              <tr>
                <td>23</td>
                <td>Quản lý danh mục Nhóm Đại biểu</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm nhóm đại biểu theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa thông tin nhóm đại biểu</td>
              </tr>
              <tr>
                <td />
                <td>
                  Thiết lập trạng thái (active/inactive) cho nhóm đại biểu
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Lựa chọn sắp xếp nhóm mặc định theo alphabet, hoặc theo thứ tự
                  được cung cấp.
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Lựa chọn sắp xếp danh sách đại biểu của nhóm mặc định theo
                  alphabet, hoặc theo thứ tự được cung cấp.
                </td>
              </tr>
              <tr>
                <td>25</td>
                <td>Quản lý Layout bàn phòng họp</td>
              </tr>
              <tr>
                <td />
                <td>
                  Thêm/sửa/xóa Layout bàn (số lượng bàn, cách sắp đặt bàn…)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Giao diện vẽ, kéo thả, sắp xếp vị trí các bàn trong layout
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp theo tiêu chí (tên, ngày tạo, số lượng bàn, ghi chú)
                </td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm theo tiêu chí</td>
              </tr>
              <tr>
                <td>26</td>
                <td>Quản lý danh mục phòng họp</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa danh mục Phòng họp</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp theo tiêu chí (tên phòng, địa điểm, số lượng thiết bị,
                  layout ...)
                </td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm theo tiêu chí (tên phòng)</td>
              </tr>
              <tr>
                <td />
                <td>Gán Trang thiết bị phục vụ cho Phòng họp</td>
              </tr>
              <tr>
                <td />
                <td>Gán Layout bàn cho Phòng họp</td>
              </tr>
              <tr>
                <td>27</td>
                <td>Quản lý sơ đồ chỗ ngồi</td>
              </tr>
              <tr>
                <td />
                <td>Chọn phiên họp, chọn phòng họp</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp bảng danh sách chỗ ngồi (sort theo số bàn, theo đã gán
                  hay chưa, theo tên đại biểu ngồi) trên layout đồ họa và layout
                  danh sách
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn 1 đại biểu tương ứng một chỗ ngồi (gắp thả trực quan)
                  trên đồ họa/add trên danh sách và Cập nhật thông tin chỗ ngồi
                  và lưu thành 1 profile để sử dụng lại
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa chỗ ngồi</td>
              </tr>
              <tr>
                <td>28</td>
                <td>Phân chỗ ngồi cho đại biểu tự động</td>
              </tr>
              <tr>
                <td />
                <td>Chọn Kỳ họp, phiên họp, chọn phòng họp</td>
              </tr>
              <tr>
                <td />
                <td>
                  Thực hiện phân chỗ ngồi tự động dựa theo các lần phân trước đó
                  (căn cứ chức vụ, vai trò là đại biểu hay khách mời, chủ trì
                  hay báo cáo) hoàn toàn trên đồ họa. Hệ thống cập nhật thông
                  tin, lưu thành 1 profile, thông báo thành công và cập nhật lại
                  danh sách
                </td>
              </tr>
              <tr>
                <td>29</td>
                <td>Quản lý quyền đăng nhập người dùng (user)</td>
              </tr>
              <tr>
                <td />
                <td>
                  Chức năng tự động gợi ý gán dựa trên họ tên khi chuyển danh bạ
                  từ nhiệm kỳ cũ qua nhiệm kỳ mới
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa/khóa quyền đăng nhập người dùng</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp theo tiêu chí (tên đăng nhập, họ tên trên danh bạ,
                  sdt, email, các trường tương ứng trên danh bạ khi đã được
                  gán...)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Tìm kiếm theo tiêu chí (tên, chức vụ, sdt, email, cơ quan công
                  tác, dự khuyết ...)
                </td>
              </tr>
              <tr>
                <td>30</td>
                <td>
                  Quản lý user dùng để login Kiosk trong trường hợp muốn hiển
                  thị các nội dung không hạn chế công khai tại Đại hội, hội nghị
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa user</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp theo tiêu chí (tên user, thứ tự hiển thị)</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm theo tiêu chí (tên user)</td>
              </tr>
              <tr>
                <td>31</td>
                <td>Quản lý danh mục Tổ thảo luận</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm tổ thảo luận theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa thông tin tổ thảo luận</td>
              </tr>
              <tr>
                <td />
                <td>Lựa chọn trạng thái (active/inactive) cho tổ thảo luận</td>
              </tr>
              <tr>
                <td />
                <td>Nhập thông tin phòng họp cho Tổ thảo luận</td>
              </tr>
              <tr>
                <td />
                <td>
                  Giao diện kéo thả, sắp xếp, chọn nhiều đại biểu vào tổ thảo
                  luận và giao diện chọn tổ thảo luận cho đại biểu
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Lựa chọn sắp xếp tổ thảo luận mặc định theo alphabet, hoặc
                  theo thứ tự được cung cấp
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Lựa chọn sắp xếp danh sách đại biểu của tổ thảo luận mặc định
                  theo alphabet, hoặc theo thứ tự được cung cấp
                </td>
              </tr>
              <tr>
                <td>32</td>
                <td>Quản lý danh sách Đoàn chủ tịch</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm đoàn chủ tịch theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách Đoàn chủ tịch</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa thông tin đoàn chủ tịch</td>
              </tr>
              <tr>
                <td />
                <td>Import danh sách đoàn chủ tịch</td>
              </tr>
              <tr>
                <td />
                <td>Export danh sách đoàn chủ tịch</td>
              </tr>
              <tr>
                <td>33</td>
                <td>Quản lý Ban Tổ chức Tổ phục vụ, Tổ An ninh)</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm nhân sự Ban tổ chức theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa thông tin nhân sự Ban tổ chức</td>
              </tr>
              <tr>
                <td />
                <td>Import danh sách nhân sự Ban tổ chức</td>
              </tr>
              <tr>
                <td />
                <td>Export danh sách nhân sự Ban tổ chức</td>
              </tr>
              <tr>
                <td>34</td>
                <td>
                  Quản lý danh sách Thư ký (Đoàn thư ký, Thư ký Hội trường/Tổ,
                  Thư ký Tổng hợp)
                </td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm thư ký theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa thông tin thư ký</td>
              </tr>
              <tr>
                <td />
                <td>
                  Gán quyền thư ký (Đoàn thư ký, Thư ký Hội trường/Tổ, Thư ký
                  Tổng hợp)
                </td>
              </tr>
              <tr>
                <td />
                <td>Import danh sách thư ký</td>
              </tr>
              <tr>
                <td />
                <td>Export danh sách thư ký</td>
              </tr>
              <tr>
                <td>35</td>
                <td>
                  Quản lý danh bạ Ban Tổ chức cán bộ phục vụ, cán bộ an ninh
                </td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm cán bộ phục vụ theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa thông tin cán bộ phục vụ</td>
              </tr>
              <tr>
                <td />
                <td>Gán quyền cho Ban Tổ chức cán bộ phục vụ, An ninh</td>
              </tr>
              <tr>
                <td />
                <td>Import danh sách cán bộ phục vụ</td>
              </tr>
              <tr>
                <td />
                <td>Export danh sách cán bộ phục vụ</td>
              </tr>
              <tr>
                <td>36</td>
                <td>Quản lý danh sách phóng viên</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm phóng viên theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa thông tin phóng viên</td>
              </tr>
              <tr>
                <td />
                <td>Import danh sách phóng viên</td>
              </tr>
              <tr>
                <td />
                <td>Export danh sách phóng viên</td>
              </tr>
              <tr>
                <td className="font-bold">II</td>
                <td className="font-bold">Xem thông tin đại biểu</td>
              </tr>
              <tr>
                <td>37</td>
                <td>Truy cập danh sách đại biểu</td>
              </tr>
              <tr>
                <td />
                <td>
                  Tìm kiếm danh sách Đại biểu theo tiêu chí tìm kiếm (ID đại
                  biểu, họ tên, giới tính, cơ quan...)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách đại biểu theo tiêu chí (ID đại biểu, họ tên,
                  giới tính, cơ quan...)
                </td>
              </tr>
              <tr>
                <td />
                <td>Chọn đại biểu từ danh sách và xem chi tiết thông tin</td>
              </tr>
              <tr>
                <td>38</td>
                <td>Truy cập danh sách phân tổ</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách tổ theo tiêu chí (ID tổ, tên tổ, ...)</td>
              </tr>
              <tr>
                <td />
                <td>
                  Tìm kiếm danh sách Đại biểu trong tổ theo tiêu chí tìm kiếm
                  (ID đại biểu, họ tên, giới tính, cơ quan...)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách đại biểu trong tổ theo tiêu chí (ID đại
                  biểu, họ tên, giới tính, cơ quan...)
                </td>
              </tr>
              <tr>
                <td className="font-bold">C</td>
                <td className="font-bold">Phân hệ Tư liệu</td>
              </tr>
              <tr>
                <td className="font-bold">I</td>
                <td className="font-bold">Quản lý Tư liệu</td>
              </tr>
              <tr>
                <td>39</td>
                <td>Quản lý danh mục loại tài liệu</td>
              </tr>
              <tr>
                <td />
                <td>Chọn và xem chi tiết loại tài liệu</td>
              </tr>
              <tr>
                <td />
                <td>
                  Tìm kiếm danh sách loại tài liệu theo các tiêu chí (tên loại
                  tài liệu)
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa loại tài liệu</td>
              </tr>
              <tr>
                <td />
                <td>Thiết lập trạng thái cho loại tài liệu</td>
              </tr>
              <tr>
                <td>40</td>
                <td>Quản lý danh mục nhóm tài liệu</td>
              </tr>
              <tr>
                <td />
                <td>Chọn và xem nhóm tài liệu</td>
              </tr>
              <tr>
                <td />
                <td>
                  Tìm kiếm danh sách nhóm tài liệu theo các tiêu chí (tên nhóm
                  tài liệu, loại tài liệu)
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa nhóm tài liệu</td>
              </tr>
              <tr>
                <td />
                <td>Đặt trạng thái nhóm tài liệu (active/ inactive)</td>
              </tr>
              <tr>
                <td>41</td>
                <td>Quản lý tài liệu liên quan công tác chỉ đạo</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách tài liệu liên quan công tác chỉ đạo theo
                  tiêu chí mặc định và theo các tiêu chí tùy chọn (tên tài liệu,
                  số trang, ngày ban hành, đơn vị ban hành)
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa tài liệu liên quan công tác chỉ đạo</td>
              </tr>
              <tr>
                <td />
                <td>
                  Thiết lập trạng thái cho tài liệu liên quan công tác chỉ đạo
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Import tài liệu/ Import ý kiến góp ý Tài liệu liên quan công
                  tác chỉ đạo
                </td>
              </tr>
              <tr>
                <td />
                <td>Export tài liệu (Excel/Word + PDF zip)</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách tài liệu liên quan công tác chỉ đạo theo
                  tiêu chí mặc định và theo các tiêu chí tùy chọn (tên tài liệu,
                  số trang, ngày ban hành, đơn vị ban hành)
                </td>
              </tr>
              <tr>
                <td>42</td>
                <td>Quản lý tài liệu nghiên cứu, thảo luận</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp tài liệu nghiên cứu, thảo luận theo tiêu chí mặc định
                  và theo tiêu chí tùy chọn (tên tài liệu, số trang, ngày ban
                  hành, đơn vị ban hành)
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa tài liệu nghiên cứu, thảo luận</td>
              </tr>
              <tr>
                <td />
                <td>
                  Thiết lập trạng thái active/inactive cho tài liệu nghiên cứu,
                  thảo luận
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Import tài liệu/ Import ý kiến góp ý Tài liệu nghiên cứu, thảo
                  luận
                </td>
              </tr>
              <tr>
                <td />
                <td>Export tài liệu (Excel/Word _+ PDF zip</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp tài liệu nghiên cứu, thảo luận theo tiêu chí mặc định
                  và theo tiêu chí tùy chọn (tên tài liệu, số trang, ngày ban
                  hành, đơn vị ban hành)
                </td>
              </tr>
              <tr>
                <td>43</td>
                <td>Quản lý tài liệu tham khảo</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách tài liệu tham khảo theo tiêu chí mặc định
                  (là tài liệu tham khảo, chia theo loại, nhóm) và theo tiêu chí
                  tìm kiếm (tên tài liệu, số trang, ngày ban hành, đơn vị ban
                  hành)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn tài liệu từ danh sách và xem chi tiết thông tin (nội
                  dung, xem ngày tháng, cơ quan ban hành, trích yếu …)
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa tài liệu tham khảo</td>
              </tr>
              <tr>
                <td />
                <td>
                  Thiết lập trạng thái active/inactive cho tài liệu tham khảo
                </td>
              </tr>
              <tr>
                <td />
                <td>Import tài liệu/ Import ý kiến góp ý Tài liệu tham khảo</td>
              </tr>
              <tr>
                <td />
                <td>Export tài liệu (Excel/Word _+ PDF zip</td>
              </tr>
              <tr>
                <td>44</td>
                <td>Quản lý Kho tài liệu chung</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp kho tài liệu theo tiêu chí mặc định và tiêu chí tùy
                  chọn khác(tên tài liệu, số trang, ngày ban hành, đơn vị ban
                  hành), thể hiện hình cây
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn tài liệu từ danh sách và xem chi tiết thông tin tài liệu
                  chung
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa tài liệu chung</td>
              </tr>
              <tr>
                <td />
                <td>
                  Thiết lập trạng thái active/inactive cho Kho tài liệu chung
                </td>
              </tr>
              <tr>
                <td />
                <td>Import tài liệu/ Import ý kiến góp ý Tài liệu trong Kho</td>
              </tr>
              <tr>
                <td />
                <td>
                  Export tài liệu (Excel/Word + PDF zip)/ Export ý kiến góp ý
                  nếu có
                </td>
              </tr>
              <tr>
                <td>45</td>
                <td>
                  Quản lý nhập tài liệu từ Hệ thống khác (Quản lý văn bản, Thư
                  viện …)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách theo tiêu chí (tên tài liệu, số trang, ngày
                  ban hành, đơn vị ban hành)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Tìm kiếm danh sách loại tài liệu theo các tiêu chí (tên tài
                  liệu, số trang, ngày ban hành, đơn vị ban hành)
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa tài liệu chung</td>
              </tr>
              <tr>
                <td />
                <td>
                  Chuyển tài liệu vào Kho tài liệu chung và có giao diện chọn để
                  phân bổ vào loại, nhóm tài liệu
                </td>
              </tr>
              <tr>
                <td />
                <td>Tương tác bằng giao thức của trục liên thông văn bản</td>
              </tr>
              <tr>
                <td>46</td>
                <td>Quản lý tiếp nhận yêu cầu tài liệu</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách yêu cầu tài liệu theo tiêu chí mặc định và
                  theo tiêu chí tùy chọn (ID đại biểu, tên tài liệu, thời gian
                  gửi yêu cầu, trạng thái xử lý yêu cầu)
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa yêu cầu mượn tài liệu</td>
              </tr>
              <tr>
                <td />
                <td>
                  Nhập thông tin của tài liệu cần phục vụ và chấp nhận chuyển
                  tài liệu đến người yêu cầu.
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Ghi nhận metadata (số trang tài liệu, số người mượn, thời gian
                  ...) trong kỳ họp.
                </td>
              </tr>
              <tr>
                <td>49</td>
                <td>Quản lý danh mục phim</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa danh mục Chủ đề phim</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/xóa phim đại hội, sửa tên phim vào danh mục</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp theo tiêu chí danh mục Chủ đề phim, phim</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa phim ảnh khỏi kỳ họp trong danh mục</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm theo tiêu chí danh mục Chủ đề phim, phim</td>
              </tr>
              <tr>
                <td>50</td>
                <td>Quản lý danh mục ảnh</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa danh mục Chủ đề ảnh</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/xóa hình ảnh, sửa tên hình ảnh vào danh mục</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp theo tiêu chí danh mục Chủ đề ảnh, hình ảnh</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm theo tiêu chí danh mục Chủ đề ảnh, hình ảnh</td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa Chủ đề ảnh</td>
              </tr>
              <tr>
                <td className="font-bold">II</td>
                <td className="font-bold">Xem Tư liệu</td>
              </tr>
              <tr>
                <td>51</td>
                <td>Xem tài liệu</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm tài liệu theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách theo tiêu chí (tên tài liệu, số trang, ngày
                  ban hành, cơ quan ban hành)
                </td>
              </tr>
              <tr>
                <td>52</td>
                <td>Xem phim ảnh</td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn thư mục Video và xem tất cả chuyên mục video trong danh
                  mục
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn chuyên mục Video và xem tất cả video trong chuyên mục
                </td>
              </tr>
              <tr>
                <td />
                <td>Xem chi tiết Video</td>
              </tr>
              <tr>
                <td />
                <td>Chọn dừng phát video</td>
              </tr>
              <tr>
                <td />
                <td>Chọn tua nhanh video</td>
              </tr>
              <tr>
                <td />
                <td>Chọn chuyển qua phát video liền trước/ liền sau</td>
              </tr>
              <tr>
                <td>53</td>
                <td>Xem hình ảnh</td>
              </tr>
              <tr>
                <td />
                <td>Chọn thư mục hình ảnh và xem tất cả các album hình ảnh</td>
              </tr>
              <tr>
                <td />
                <td>Chọn album hình ảnh và xem tất cả ảnh trong album</td>
              </tr>
              <tr>
                <td />
                <td>Chọn xem chi tiết hình ảnh</td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn chuyển qua ảnh kế tiếp và trước đó mà không cần thoát ảnh
                </td>
              </tr>
              <tr>
                <td />
                <td>Phóng to hoặc thu nhỏ ảnh</td>
              </tr>
              <tr>
                <td />
                <td>Xoay ảnh theo các hướng</td>
              </tr>
              <tr>
                <td className="font-bold">D</td>
                <td className="font-bold">Phân hệ Đăng nhập</td>
              </tr>
              <tr>
                <td className="font-bold">I</td>
                <td className="font-bold">Quản lý id/password</td>
              </tr>
              <tr>
                <td>54</td>
                <td>Quản lý id/password cho người dùng</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm người dùng theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Chọn người dùng và Cấp id/pass cho người dùng</td>
              </tr>
              <tr>
                <td />
                <td>Khóa/ mở khóa tài khoản người dùng</td>
              </tr>
              <tr>
                <td />
                <td>
                  Xóa tài khoản người dùng (danh bạ đại biểu gán với tài khoản
                  vẫn còn, chỉ xóa tài khoản không xóa danh bạ)
                </td>
              </tr>
              <tr>
                <td>55</td>
                <td>Đăng nhập id/password và đăng xuất</td>
              </tr>
              <tr>
                <td />
                <td>
                  Nhập id và pass để đăng nhập, hệ thống thông báo đăng nhập
                  thành công hay thất bại
                </td>
              </tr>
              <tr>
                <td />
                <td>Chọn mục đăng xuất và thoát khỏi hệ thống</td>
              </tr>
              <tr>
                <td>56</td>
                <td>Cấp lại mật khẩu</td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn người dùng và thực hiện tạo mật khẩu mới cho người dùng
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn nhiều người dùng và thực hiện tạo mật khẩu cho nhiều
                  người dùng
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Export danh sách tài khoản cấp lại mật khẩu ra file excel
                </td>
              </tr>
              <tr>
                <td className="font-bold">II</td>
                <td className="font-bold">Quản lý Thẻ từ</td>
              </tr>
              <tr>
                <td>57</td>
                <td>Quản lý thẻ từ trong danh sách thẻ hợp lệ</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm tài khoản thẻ theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa tài khoản thẻ</td>
              </tr>
              <tr>
                <td />
                <td>Kết nối đầu đọc thẻ, nhập thẻ liên tiếp theo thứ tự</td>
              </tr>
              <tr>
                <td />
                <td>
                  Nhập danh sách thẻ từ qua file Excel (nhập số lượng lớn, có
                  tùy chọn xóa dữ liệu cũ, nhập dữ liệu mới hoặc chỉ cập nhật dữ
                  liệu mới)
                </td>
              </tr>
              <tr>
                <td />
                <td>Xuất danh sách thẻ từ ra Excel</td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn kiểm tra thẻ có nằm trong danh sách thẻ hợp lệ hay không
                </td>
              </tr>
              <tr>
                <td>58</td>
                <td>Quản lý ánh xạ thẻ từ - thông tin người dùng</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>
                  Tìm kiếm người dùng theo các tiêu chí (Đại biểu, Mã thẻ, Trạng
                  thái cấp thẻ)
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa Ánh xạ thẻ - thông tin người dùng</td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn người dùng, đọc thẻ thông qua đầu đọc, gán thẻ từ cho
                  người dùng
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Nhập (ánh xạ) thẻ từ vào thông tin người dùng qua file Excel
                  (nhập số lượng lớn, có tùy chọn xóa dữ liệu cũ, nhập dữ liệu
                  mới hoặc chỉ cập nhật dữ liệu mới)
                </td>
              </tr>
              <tr>
                <td />
                <td>Xuất ánh xạ thẻ từ - thông tin người dùng ra Excel</td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn kiểm tra thẻ đã có ánh xạ với thông tin người dùng hay
                  chưa
                </td>
              </tr>
              <tr>
                <td>59</td>
                <td>Quản lý thẻ tạm</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm thẻ, người dùng theo các tiêu chí (Mã thẻ)</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa thẻ tạm</td>
              </tr>
              <tr>
                <td />
                <td>Kết nối đầu đọc thẻ, nhập thẻ tạm liên tiếp theo thứ tự</td>
              </tr>
              <tr>
                <td />
                <td>Cài đặt thời gian hiệu lực của thẻ tạm</td>
              </tr>
              <tr>
                <td />
                <td>Xuất danh sách thẻ tạm ra Excel</td>
              </tr>
              <tr>
                <td />
                <td>Quản lý cấp phát và thu hồi thẻ tạm</td>
              </tr>
              <tr>
                <td className="font-bold">III</td>
                <td className="font-bold">Quản lý QRcode</td>
              </tr>
              <tr>
                <td>60</td>
                <td>Quản lý QRcode của người dùng/khách mời</td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn và hiển thị danh sách người dùng/khách mời theo đơn vị
                  cần tạo QRcode xem đã có/chưa có QR code
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn một/nhiều người dùng trong danh sách và tạo QR code cho
                  người dùng, thông báo tạo QR code thành công
                </td>
              </tr>
              <tr>
                <td />
                <td>Hiển thị QR code đã tạo của từng người dùng</td>
              </tr>
              <tr>
                <td className="font-bold">IV</td>
                <td className="font-bold">Quản lý thiết bị đăng nhập</td>
              </tr>
              <tr>
                <td>61</td>
                <td>Quản lý Thiết bị đăng nhập</td>
              </tr>
              <tr>
                <td />
                <td>
                  Tự động thêm thiết bị kèm thông tin đại biểu khi đại biểu đăng
                  nhập trên thiết bị (mã MAC Address, IP, Hostname, OS, Thông
                  tin đại biểu)
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa thiết bị đăng nhập</td>
              </tr>
              <tr>
                <td />
                <td>Xem danh sách thiết bị đăng nhập</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp theo tiêu chí (ID người dùng, IMEI, MAC)</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm theo tiêu chí (ID người dùng, IMEI, MAC)</td>
              </tr>
              <tr>
                <td className="font-bold">V</td>
                <td className="font-bold">Quản lý Điểm danh</td>
              </tr>
              <tr>
                <td>62</td>
                <td>Quản lý thiết bị điểm danh</td>
              </tr>
              <tr>
                <td />
                <td>
                  Tìm kiếm thiết bị điểm danh theo các tiêu chí (tên, IP, cán bộ
                  an ninh)
                </td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa thiết bị điểm danh</td>
              </tr>
              <tr>
                <td />
                <td>Gán thiết bị điểm danh và cán bộ Ban Tổ chức (an ninh)</td>
              </tr>
              <tr>
                <td>63</td>
                <td>Điểm danh bằng thẻ từ</td>
              </tr>
              <tr>
                <td />
                <td>
                  Quẹt thẻ từ, hệ thống đọc thông tin trên thẻ từ, kiểm tra
                  thông tin và quyền truy cập. Hiện thông báo điểm danh thành
                  công hay thất bại
                </td>
              </tr>
              <tr>
                <td>64</td>
                <td>Điểm danh bằng QR code</td>
              </tr>
              <tr>
                <td />
                <td>
                  Quẹt mã QR code, hệ thống đọc thông tin QR code in trên giấy
                  mời, kiểm tra thông tin và quyền truy cập. Hiện thông báo điểm
                  danh thành công hay thất bại
                </td>
              </tr>
              <tr>
                <td>65</td>
                <td>Điểm danh giúp (nhập tay)</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách tiêu chí mặc định (ngày hiện tại) và các
                  theo tiêu chí tùy chọn (ID đại biểu, tên, kết quả điểm danh,
                  ngày điểm danh)
                </td>
              </tr>
              <tr>
                <td />
                <td>Chọn và xem chi tiết mục điểm danh từ danh sách</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa thông tin điểm danh</td>
              </tr>
              <tr>
                <td>66</td>
                <td>Điểm danh (Họp trực tuyến)</td>
              </tr>
              <tr>
                <td />
                <td>Xem kết quả điểm danh</td>
              </tr>
              <tr>
                <td>67</td>
                <td>Đăng ký lý do vắng</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách xin vắng mặt với các tiêu chí mặc định (ngày
                  hiện tại) và theo tiêu chí tùy chọn khác (ID đại biểu, họ tên
                  đại biểu, ngày xin vắng,…)
                </td>
              </tr>
              <tr>
                <td />
                <td>Đăng ký xin vắng mặt cho đại biểu, tổ phục vụ</td>
              </tr>
              <tr>
                <td />
                <td>Sửa/xóa thông tin xin vắng mặt</td>
              </tr>
              <tr>
                <td>68</td>
                <td>Cấu hình kết nối Phần mềm Camera AI</td>
              </tr>
              <tr>
                <td />
                <td>
                  Ban tổ chức (Tổ phục vụ) chọn chức năng Đồng bộ dữ liệu. Hệ
                  thống hiển thị màn hình Đồng bộ dữ liệu.
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Ban tổ chức (Tổ phục vụ) chọn chức năng Đồng bộ dữ liệu người
                  dùng từ Hệ thống này qua Phần mềm Camera AI (metadata thông
                  tin đại biểu, khách mời, thành phần mở rộng và hình ảnh kèm
                  theo). Hệ thống Kiểm tra kết nối đến Phần mềm Camera AI và báo
                  kết quả thành công hay thất bại lại cho người dùng.
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Ban tổ chức (Tổ phục vụ) chọn chức năng Tải file kết quả trên
                  màn hình Đồng bộ dữ liệu. Hệ thống thực hiện xuất dữ liệu ra
                  file excel cho người dùng.
                </td>
              </tr>
              <tr>
                <td>69</td>
                <td>Điểm danh bằng Camera AI</td>
              </tr>
              <tr>
                <td />
                <td>
                  Ban tổ chức (Tổ phục vụ) mở giao diện điểm danh bằng khuôn mặt
                  trên web (viết mới, không thay đổi giao diện điểm danh thẻ).
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Hệ thống nhận kết quả điểm danh từ Phần mềm Camera AI. Đối
                  chiếu thông tin điểm danh này và thời gian diễn ra của Kỳ họp,
                  phiên họp, tổ thảo luận để thực hiện điểm danh. Giao diện điểm
                  danh bằng khuôn mặt hiển thị hình ảnh và thông tin đại biểu
                  mỗi khi có đại biểu được điểm danh.
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Hệ thống nhận kết quả điểm danh từ Phần mềm Camera AI. Đối
                  chiếu thông tin điểm danh này và thời gian diễn ra của Kỳ họp,
                  phiên họp để thực hiện điểm danh. Giao diện điểm danh bằng
                  khuôn mặt hiển thị hình ảnh và thông tin Khách mời mỗi khi có
                  Khách mời được điểm danh.
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Hệ thống nhận kết quả điểm danh từ Phần mềm Camera AI. Đối
                  chiếu thông tin điểm danh này và thời gian diễn ra của Kỳ họp,
                  phiên họp, tổ thảo luận để thực hiện điểm danh. Giao diện điểm
                  danh bằng khuôn mặt hiển thị hình ảnh và thông tin Thành phần
                  mở rộng mỗi khi có Thành phần mở rộng được điểm danh.
                </td>
              </tr>
              <tr>
                <td className="font-bold">VI</td>
                <td className="font-bold">Thống kê số liệu điểm danh</td>
              </tr>
              <tr>
                <td>70</td>
                <td>Thống kê số liệu điểm danh tại Hội trường</td>
              </tr>
              <tr>
                <td />
                <td>
                  Thống kê điểm danh tại Hội trường với các tiêu chí mặc định
                  (ngày hiện tại) và theo các tiêu chí tùy chọn khác từ danh
                  sách tiêu chí thống kê (đại biểu có mặt, vắng mặt tại Hội
                  trường,....)
                </td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm đại biểu có mặt, vắng mặt</td>
              </tr>
              <tr>
                <td />
                <td>Xem lý do vắng</td>
              </tr>
              <tr>
                <td />
                <td>Kết xuất thống kê ra word/Excel/PDF</td>
              </tr>
              <tr>
                <td />
                <td>
                  Hiển thị biểu đồ điểm danh theo các tiêu chí mặc định (ngày
                  hiện tại) và theo các tiêu chí chọn từ danh sách tiêu chí
                  thống kê
                </td>
              </tr>
              <tr>
                <td>71</td>
                <td>Thống kê số liệu điểm danh tại Tổ thảo luận</td>
              </tr>
              <tr>
                <td />
                <td>
                  Thống kê điểm danh chia theo Tổ thảo luận theo tiêu chí mặc
                  định (ngày hiện tại) và theo các tiêu chí chọn từ danh sách
                  tiêu chí thống kê
                </td>
              </tr>
              <tr>
                <td />
                <td>Xem danh sách đại biểu có mặt, vắng mặt</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm đại biểu có mặt, vắng mặt</td>
              </tr>
              <tr>
                <td />
                <td>Xem lý do vắng</td>
              </tr>
              <tr>
                <td />
                <td>Export dữ liệu thống kê ra file Excel, Word, Pdf</td>
              </tr>
              <tr>
                <td />
                <td>
                  Hiển thị biểu đồ điểm danh Tổ thảo luận theo tiêu chí mặc định
                  (ngày hiện tại) và theo các tiêu chí chọn từ danh sách tiêu
                  chí thống kê
                </td>
              </tr>
              <tr>
                <td className="font-bold">E</td>
                <td className="font-bold">Phân hệ Điều hành</td>
              </tr>
              <tr>
                <td className="font-bold">I</td>
                <td className="font-bold">Điều hành phát biểu Hội trường</td>
              </tr>
              <tr>
                <td>72</td>
                <td>Hiển thị thông tin đại biểu phát biểu trên màn hình lớn</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách đại biểu phát biểu theo tiêu chí mặc định và
                  theo các tiêu chí tìm kiếm (họ tên đại biểu, đề tài phát biểu,
                  thứ tự phát biểu)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn đăng ký phát biểu từ danh sách và cho phép bắt đầu phát
                  biểu
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn hiển thị thông tin đại biểu phát biểu trên màn hình lớn
                </td>
              </tr>
              <tr>
                <td>73</td>
                <td>Quản lý thời gian phát biểu (đếm lùi, thông báo hết)</td>
              </tr>
              <tr>
                <td />
                <td>
                  Thiết lập thời lượng phát biểu, hiển thị thời lượng phát biểu
                  còn lại
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Thiết lập thời điểm cảnh báo thời lượng phát biểu đã hết
                </td>
              </tr>
              <tr>
                <td className="font-bold">II</td>
                <td className="font-bold">Biểu quyết</td>
              </tr>
              <tr>
                <td>74</td>
                <td>Quản lý nội dung biểu quyết</td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa nội dung biểu quyết</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách nội dung biểu quyết theo tiêu chí mặc định
                  và theo các tiêu chí tùy chọn (nội dung biểu quyết)
                </td>
              </tr>
              <tr>
                <td className="font-bold">F</td>
                <td className="font-bold">Phân hệ Thư ký</td>
              </tr>
              <tr>
                <td className="font-bold">I</td>
                <td className="font-bold">Quản lý Thư ký</td>
              </tr>
              <tr>
                <td>76</td>
                <td>Quản lý danh mục Lĩnh vực</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách theo tiêu chí mặc định và theo các tiêu chí
                  tùy chọn khác (tên Lĩnh vực, thứ tự hiển thị)
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa thông tin Lĩnh vực</td>
              </tr>
              <tr>
                <td>77</td>
                <td>Phân quyền Lĩnh vực phụ trách cho từng Thư ký</td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn thư ký từ danh sách và gán Lĩnh vực phụ trách cho thư ký
                </td>
              </tr>
              <tr>
                <td />
                <td>Xóa Lĩnh vực phụ trách cho thư ký</td>
              </tr>
              <tr>
                <td>78</td>
                <td>Phân Tổ thảo luận cho Thư ký tổ</td>
              </tr>
              <tr>
                <td />
                <td>
                  Ban tổ chức (Tổ phục vụ) mở chức năng phân tổ thảo luận cho
                  thư ký tổ. Hệ thống hiển thị giao diện phân tổ thảo luận
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Ban tổ chức (Tổ phục vụ) gán Thư ký tổ vào một tổ xác định.
                  Một thư ký tổ chỉ được gán vào 1 tổ thảo luận
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Ban tổ chức (Tổ phục vụ) xóa Thư ký tổ khỏi một tổ xác định.
                </td>
              </tr>
              <tr>
                <td>79</td>
                <td>Thiết lập Cấp, Báo cáo, Lĩnh vực báo cáo</td>
              </tr>
              <tr>
                <td />
                <td>
                  Ban tổ chức (Tổ phục vụ) chọn chức năng xem danh mục Cấp báo
                  cáo theo cấu trúc cây. Hệ thống hiển thị màn hình chức năng
                  Xem Cấp báo cáo, Báo cáo và Lĩnh vực báo cáo theo cấu trúc cây
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Tại màn hình theo cấu trúc cây, Ban tổ chức (Tổ phục vụ) chọn
                  nhập mới Cấp báo cáo (cấp trên cùng). Người dùng có thể nhập
                  một hoặc nhiều Cấp báo cáo cùng lúc. Hệ thống kiểm tra thông
                  tin, nếu hợp lệ thì lưu thông tin vào CSDL, nếu không hợp lệ
                  thì hiển thị thông báo lỗi cụ thể.
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Tại màn hình theo cấu trúc cây, Ban tổ chức (Tổ phục vụ) chọn
                  Cấp báo cáo, chọn nhập mới Báo cáo (cấp giữa). Người dùng có
                  thể nhập một hoặc nhiều Báo cáo cùng lúc. Hệ thống kiểm tra
                  thông tin, nếu hợp lệ thì lưu thông tin vào CSDL, nếu không
                  hợp lệ thì hiển thị thông báo lỗi cụ thể..
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Tại màn hình theo cấu trúc cây, Ban tổ chức (Tổ phục vụ) chọn
                  Báo cáo, chọn nhập mới Lĩnh vực báo cáo (cấp cuối). Người dùng
                  có thể nhập một hoặc nhiều Lĩnh vực báo cáo cùng lúc. Hệ thống
                  kiểm tra thông tin, nếu hợp lệ thì lưu thông tin vào CSDL, nếu
                  không hợp lệ thì hiển thị thông báo lỗi cụ thể.
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Tại màn hình theo cấu trúc cây, Ban tổ chức (Tổ phục vụ) chọn
                  Cấp báo cáo, Báo cáo hoặc Lĩnh vực báo cáo rồi nhấn nút Xóa.
                  Hệ thống xóa nút đó.
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Tại màn hình theo cấu trúc cây, Ban tổ chức (Tổ phục vụ) chọn
                  Báo cáo hoặc Lĩnh vực báo cáo rồi nhấn nút Ctrl-C và dán
                  Ctrl-V. Hệ thống copy nút đó dán vào vị trí mới.
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Tại màn hình theo cấu trúc cây, Ban tổ chức (Tổ phục vụ) nhấn
                  chuột double click vào bất kỳ node nào để sửa lại tên của node
                  đó
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Ban tổ chức (Tổ phục vụ) có thể kéo thả các Báo cáo vào Cấp
                  báo cáo, Lĩnh vực báo cáo vào Báo cáo và thay đổi thứ tự Cấp
                  báo cáo, Báo cáo, Lĩnh vực báo cáo.
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Ban tổ chức (Tổ phục vụ) có thể chọn màu biểu trưng cho từng
                  Cấp báo cáo
                </td>
              </tr>
              <tr>
                <td className="font-bold">II</td>
                <td className="font-bold">Quản lý phát biểu</td>
              </tr>
              <tr>
                <td>80</td>
                <td>Ghi nhận và tổng hợp phát biểu tại Hội trường</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách nội dung theo tiêu chí mặc định và theo tiêu
                  chí tùy chọn khác (họ tên đại biểu, chủ đề phát biểu)
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa nội dung chi tiết phát biểu</td>
              </tr>
              <tr>
                <td />
                <td>Kiểm trùng các nội dung phát biểu (cùng chủ đề)</td>
              </tr>
              <tr>
                <td />
                <td>Export danh sách ra file Excel, Word, Pdf</td>
              </tr>
              <tr>
                <td>81</td>
                <td>Ghi nhận và tổng hợp phát biểu tại Tổ Thảo luận</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách nội dung phát biểu theo tiêu chí mặc định và
                  theo tiêu chí tùy chọn khác (họ tên đại biểu, chủ đề phát
                  biểu, nội dung phát biểu)
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa nội dung phát biểu</td>
              </tr>
              <tr>
                <td />
                <td>Kiểm trùng các nội dung phát biểu (cùng chủ đề)</td>
              </tr>
              <tr>
                <td />
                <td>Export danh sách ra file Excel, Word, Pdf</td>
              </tr>
              <tr>
                <td>82</td>
                <td>Biên tập nội dung phát biểu</td>
              </tr>
              <tr>
                <td />
                <td>
                  Tiếp nhận dữ liệu tiếng nói và xử lý, Trả lại kết quả xử lý từ
                  dữ liệu âm thanh sang text, hiển thị nội dung phát biểu dạng
                  văn bản
                </td>
              </tr>
              <tr>
                <td />
                <td>Cho phép chèn nội dung lĩnh vực, chủ đề</td>
              </tr>
              <tr>
                <td />
                <td>Xác nhận kết thúc phát biểu</td>
              </tr>
              <tr>
                <td className="font-bold">III</td>
                <td className="font-bold">Kênh hỗ trợ</td>
              </tr>
              <tr>
                <td>83</td>
                <td>Quản lý kênh nhóm nhắn tin</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách kênh thông tin trao đổi nội bộ theo tiêu chí
                  mặc định và theo tiêu chí tùychọn khác (tên kênh,...)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn kênh thông tin trao đổi nội bộ và xem thông tin chi tiết
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa kênh trao đổi nội bộ</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/xóa người dùng vào kênh</td>
              </tr>
              <tr>
                <td>84</td>
                <td>Nhắn tin nội bộ (cá nhân, kênh nhóm)</td>
              </tr>
              <tr>
                <td />
                <td>Tạo Instant Message</td>
              </tr>
              <tr>
                <td />
                <td>Chọn kênh thông tin</td>
              </tr>
              <tr>
                <td />
                <td>Gửi Instant Message</td>
              </tr>
              <tr>
                <td />
                <td>Nhận Instant Message</td>
              </tr>
              <tr>
                <td>85</td>
                <td>
                  Yêu cầu hỗ trợ (y tế, trợ giúp, vật dụng, hướng dẫn, sạc pin
                  …)
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm/hủy yêu cầu hỗ trợ</td>
              </tr>
              <tr>
                <td />
                <td>Gửi yêu cầu hỗ trợ, hệ thống cập nhật quá trình hỗ trợ</td>
              </tr>
              <tr>
                <td />
                <td>Chọn kết thúc yêu cầu hỗ trợ khi đã xử lý xong</td>
              </tr>
              <tr>
                <td className="font-bold">G</td>
                <td className="font-bold">Phân hệ Quản trị</td>
              </tr>
              <tr>
                <td className="font-bold">I</td>
                <td className="font-bold">Quản lý quyền</td>
              </tr>
              <tr>
                <td>86</td>
                <td>Quản lý Danh mục các quyền theo vai trò người dùng</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách Danh mục các quyền theo tiêu chí mặc định và
                  theo các tiêu chí tùy chọn khác
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa quyền</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/Gỡ chức năng vào quyền</td>
              </tr>
              <tr>
                <td>87</td>
                <td>Phân quyền cho người dùng</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa quyền cho người dùng</td>
              </tr>
              <tr>
                <td className="font-bold">II</td>
                <td className="font-bold">
                  Quản lý các module giao diện cơ bản trên Trang chủ theo quyền
                </td>
              </tr>
              <tr>
                <td>88</td>
                <td>Quản lý module giao diện cơ bản (chức năng)</td>
              </tr>
              <tr>
                <td />
                <td>
                  Hiển thị danh sách control theo tiêu chí mặc định hoặc tiêu
                  chí tìm kiếm (tên control, kiểu control)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách theo tiêu chí (tên control, kiểu control)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn control từ danh sách, xóa, sửa, thêm control vào module
                  giao diện cơ bản
                </td>
              </tr>
              <tr>
                <td>89</td>
                <td>
                  Thiết lập cấu hình các module giao diện cơ bản cho các trang
                  thành phần ( trang Quản trị, trang Ban tổ chức (Tổ phục vụ, an
                  ninh), trang Thư ký Tổng hợp, Tổ thảo luận, Hội trường), trang
                  Đại biểu, trang Đoàn Chủ tịch, trang Đoàn Thư ký, trang Thông
                  tin chung cho Khách mời đại diện (quản trị trên web, để áp
                  xuống giao diện mobile))
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm, xóa, sửa các module giao diện trang thành phần</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp vị trí các module giao diện trang thành phần</td>
              </tr>
              <tr>
                <td />
                <td>Tùy chỉnh màu sắc cho các trang thành phần</td>
              </tr>
              <tr>
                <td />
                <td>
                  Quản lý nội dung text riêng của các trang thành phần (không
                  thuộc module giao diện cơ bản)
                </td>
              </tr>
              <tr>
                <td className="font-bold">III</td>
                <td className="font-bold">Quản lý cấu hình hệ thống</td>
              </tr>
              <tr>
                <td>90</td>
                <td>Cấu hình các tham số chung của hệ thống</td>
              </tr>
              <tr>
                <td />
                <td>
                  Hiển thị danh sách các cấu hình (độ phức tạp của mật khẩu,
                  thời gian timeout của user Kiosk, thời gian expire session,
                  password mặc định, tùy chọn mã hóa...)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Lưu và chọn cấu hình (độ phức tạp của mật khẩu, thời gian
                  timeout của user Kiosk, thời gian expire session, password mặc
                  định, tùy chọn mã hóa...)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Thực hiện xóa dữ liệu được phép khỏi CSDL, thông báo xóa thành
                  công
                </td>
              </tr>
              <tr>
                <td className="font-bold">H</td>
                <td className="font-bold">Phân hệ Internet</td>
              </tr>
              <tr>
                <td className="font-bold">I</td>
                <td className="font-bold">Quản lý Đăng nhập</td>
              </tr>
              <tr>
                <td>91</td>
                <td>Đăng nhập ID/Password (dành cho BTC)</td>
              </tr>
              <tr>
                <td />
                <td>Nhập ID/pass để đăng nhập</td>
              </tr>
              <tr>
                <td>92</td>
                <td>Cấp lại mật khẩu (Qua SMS)</td>
              </tr>
              <tr>
                <td />
                <td>Chọn người dùng từ danh sách và cấp lại mật khẩu</td>
              </tr>
              <tr>
                <td />
                <td>Gửi mật khẩu mới đến số điện thoại người dùng</td>
              </tr>
              <tr>
                <td />
                <td>
                  Nâng cấp cổng kết nối với hệ thống SMS có sẵn để gửi mật khẩu
                  mới đến số điện thoại người dùng
                </td>
              </tr>
              <tr>
                <td className="font-bold">II</td>
                <td className="font-bold">SMS/Email</td>
              </tr>
              <tr>
                <td>93</td>
                <td>Quản lý và soạn biểu mẫu thư mời</td>
              </tr>
              <tr>
                <td />
                <td>
                  Chèn file biểu mẫu template Word với các từ khóa tham chiếu
                  Mail Merge
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Cấu hình các từ khóa tham chiếu Mail Merge ánh xạ với thông
                  tin trong CSDL
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Soạn và lưu nội dung Thư mời dựa trên biểu mẫu template Word
                  xác định theo danh sách đại biểu, khách mời của một kỳ họp
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Nhúng QRcode (loại chỉ dành cho thư mời, dùng điểm danh) cùa
                  cá nhân, tổ chức vào thư mời.
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách biểu mẫu tin gửi theo tiêu chí mặc định hoặc
                  theo tiêu chí tìm kiếm (tên biểu mẫu, ngày soạn, người soạn.,
                  nội dung ..)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn và xem chi tiết các thư mời được tạo liên tiếp nhau từ
                  file template Word một cách nhanh chóng
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa biểu mẫu thư mời.</td>
              </tr>
              <tr>
                <td>94</td>
                <td>Quản lý và soạn biểu mẫu tin nhắn</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách biểu mẫu tin gửi theo tiêu chí mặc định hoặc
                  theo tiêu chí tìm kiếm (tên biểu mẫu, ngày soạn, người soạn,
                  nội dung...)
                </td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa biểu mẫu thư mời</td>
              </tr>
              <tr>
                <td>95</td>
                <td>
                  Gửi nhắn tin SMS và Quản lý trạng thái tin nhắn SMS đã gửi
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Tạo nội dung SMS theo biểu mẫu quy định và gửi SMS đến nhóm số
                  điện thoại người dùng
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách SMS theo tiêu chí mặc định hoặc tiêu chí tìm
                  kiếm (nội dung SMS, người nhận, thời gian gửi, trạng thái gửi)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn 1 SMS đã gửi từ danh sách và xem chi tiết SMS đã gửi,
                  trạng thái thành công/ thất bại
                </td>
              </tr>
              <tr>
                <td>96</td>
                <td>
                  Gửi email thư mời, thông báo và Quản lý trạng thái email thông
                  báo đã gửi
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Tạo nội dung gửi Email và gửi Email theo thời gian lựa chọn
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách Email theo tiêu chí mặc định (tiêu đề email,
                  người nhận, thời gian gửi, trạng thái gửi) hoặc theo tiêu chí
                  tìm kiếm
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn 1 email đã gửi từ danh sách và xem chi tiết email đã gửi,
                  trạng thái thành công/ thất bại
                </td>
              </tr>
              <tr>
                <td className="font-bold">I</td>
                <td className="font-bold">Phân hệ Khác</td>
              </tr>
              <tr>
                <td className="font-bold">I</td>
                <td className="font-bold">Hệ thống</td>
              </tr>
              <tr>
                <td>97</td>
                <td>Mã hóa file trên system</td>
              </tr>
              <tr>
                <td />
                <td>
                  Nhúng watermark vào file tại client, theo người dùng để phát
                  hiện file lộ lọt từ người dùng nào
                </td>
              </tr>
              <tr>
                <td />
                <td>Thông báo file có chỉnh sửa</td>
              </tr>
              <tr>
                <td className="font-bold">II</td>
                <td className="font-bold">Thông báo</td>
              </tr>
              <tr>
                <td>98</td>
                <td>
                  Thông báo có yêu cầu tài liệu mới, yêu cầu hỗ trợ mới, tin
                  nhắn mới
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Người dùng gửi yêu cầu tài liệu mới, yêu cầu hỗ trợ mới, gửi
                  tin nhắn mới. Hệ thống gửi realtime đến người liên quan
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn thông báo yêu cầu mới, yêu cầu hỗ trợ, tin nhắn mới và
                  xem chi tiết thông tin
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Tăng biểu tượng đếm số thông báo chưa đọc lên 1 và giảm 1 sau
                  khi đọc
                </td>
              </tr>
              <tr>
                <td />
                <td className="font-bold">Ứng dụng MOBILE</td>
              </tr>
              <tr>
                <td className="font-bold">A</td>
                <td className="font-bold">Phân hệ Đại hội, hội nghị</td>
              </tr>
              <tr>
                <td className="font-bold">I</td>
                <td className="font-bold">Xem Thông tin Đại hội, hội nghị</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Xem thông tin Đại hội, hội nghị (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm kỳ Đại hội, hội nghị</td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn và xem chi tiết các nội dung của các kỳ Đại hội, hội nghị
                  trước đó
                </td>
              </tr>
              <tr>
                <td />
                <td>Chọn ngày và xem chi tiết chương trình</td>
              </tr>
              <tr>
                <td />
                <td>Chọn ngày và xem chi tiết Thông báo</td>
              </tr>
              <tr>
                <td />
                <td>Chọn ngày và xem chi tiết Thông cáo bao chí</td>
              </tr>
              <tr>
                <td className="font-bold">B</td>
                <td className="font-bold">Phân hệ nhân sự</td>
              </tr>
              <tr>
                <td className="font-bold">I</td>
                <td className="font-bold">Xem thông tin đại biểu</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Truy cập danh sách đại biểu (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách theo tiêu chí mặc định (họ tên đại biểu,
                  giới tính, chức vụ, cơ quan) hoặc theo tiêu chí tìm kiếm được
                  chọn
                </td>
              </tr>
              <tr>
                <td />
                <td>Chọn xem chi tiết thông tin đại biểu từ danh sách</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Truy cập danh sách phân tổ (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>Chọn và xem danh sách tổ</td>
              </tr>
              <tr>
                <td />
                <td>Chọn và xem danh sách đại biểu trong tổ</td>
              </tr>
              <tr>
                <td />
                <td>
                  Tìm kiếm danh sách Đại biểu trong tổ theo tiêu chí tìm kiếm
                  (ID đại biểu, họ tên, giới tính, cơ quan...)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách đại biểu trong tổ theo tiêu chí (ID đại
                  biểu, họ tên, giới tính, cơ quan...)
                </td>
              </tr>
              <tr>
                <td />
                <td>Chọn đại biểu từ danh sách và xem chi tiết thông tin</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Đổi mật khẩu/ Quên mật khẩu</td>
              </tr>
              <tr>
                <td />
                <td>
                  Người dùng chọn chức năng Đổi mật khẩu, nhập thông tin Mật
                  khẩu cũ, Mật khẩu mới, Xác nhận mật khẩu mới và nhấn Lưu. Hệ
                  thống kiểm tra thông tin, nếu hợp lệ thì lưu thông tin vào
                  CSDL, nếu không hợp lệ thì hiển thị thông báo lỗi cụ thể.
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Người dùng chọn chức năng Quên mật khẩu (ở màn hình Login). Hệ
                  thống hiện mục nhập SĐT và gửi OTP khi đại biểu nhập xong.
                  Trên màn hình này cũng gợi ý các cách thức đăng nhập khác như
                  quét QR code hoặc nhờ cán bộ kỹ thuật tại Hội trường
                </td>
              </tr>
              <tr>
                <td>5</td>
                <td>Ban tổ chức login xem thông tin</td>
              </tr>
              <tr>
                <td />
                <td>
                  Ban tổ chức Tổ phục vụ có quyền login trên máy tính bảng xem
                  thông tin của đại biểu, khách mời, thành phần mở rộng, thông
                  tin đại hội, thông tin chỗ ngồi
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Ban tổ chức Tổ phục vụ có quyền xem thông tin QR Code login
                  của đại biểu, khách mời, thành phần mở rộng. Hệ thống hiển thị
                  QR Code trên màn hình thiết bị.
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Người dùng xoay màn hình ngang hoặc màn hình dọc. Hệ thống tự
                  động hiển thị giao diện phù hợp với kích cỡ màn hình.
                </td>
              </tr>
              <tr>
                <td className="font-bold">C</td>
                <td className="font-bold">Phân hệ Tư liệu</td>
              </tr>
              <tr>
                <td className="font-bold">I</td>
                <td className="font-bold">Xem Tư liệu</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Xem tài liệu (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp danh sách theo các tiêu chí</td>
              </tr>
              <tr>
                <td />
                <td>Chọn xem chi tiết nội dung tài liệu từ danh sách</td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn chế độ đảo màu bảo vệ mắt hoặc không đảo màu khi xem file
                  tài liệu
                </td>
              </tr>
              <tr>
                <td>5</td>
                <td>Ghi chú lên tài liệu (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>Thêm ghi chú vào file</td>
              </tr>
              <tr>
                <td />
                <td>Bôi màu ghi chú trên file</td>
              </tr>
              <tr>
                <td />
                <td>Đánh dấu, khoanh vùng đánh dấu trên file</td>
              </tr>
              <tr>
                <td />
                <td>Xóa các đánh dấu hay ghi chú</td>
              </tr>
              <tr>
                <td />
                <td>Phóng to, thu nhỏ tài liệu</td>
              </tr>
              <tr>
                <td />
                <td>Xoay toàn bộ tài liệu, xoay tài liệu theo trang</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Góp ý tài liệu (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>Xem trực tuyến tài liệu họp</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa góp ý</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Xem vị trí ngồi trên sơ đồ (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>Chọn phiên họp và Xem vị trí ngồi trên sơ đồ</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Xem phim ảnh (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn thư mục video và xem danh sách tất cả các chuyên mục
                  Video
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn chuyên mục Video và tất cả Video theo chuyên mục đó
                </td>
              </tr>
              <tr>
                <td />
                <td>Xem chi tiết Video trong danh mục video</td>
              </tr>
              <tr>
                <td />
                <td>Chọn dừng, nhảy sang video kế</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Xem hình ảnh (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>Chọn thư mục hình ảnh và xem tất cả chuyên mục hình ảnh</td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn chuyên mục ảnh và xem tất cả ảnh theo chuyên mục đó
                </td>
              </tr>
              <tr>
                <td />
                <td>Xem chi tiết album hình ảnh trong danh mục hình ảnh</td>
              </tr>
              <tr>
                <td />
                <td>Chọn kế tiếp để xem ảnh kế tiếp</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Yêu cầu đăng ký mượn tài liệu (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách theo tiêu chí mặc định(họ tên đại biểu, tên
                  tài liệu, thời gian mượn, trạng thái xử lý) hoặc theo tiêu chí
                  tìm kiếm được chọn
                </td>
              </tr>
              <tr>
                <td />
                <td>Đăng ký mượn tài liệu</td>
              </tr>
              <tr>
                <td />
                <td>Sửa/xóa thông tin đăng ký</td>
              </tr>
              <tr>
                <td />
                <td>Chọn tài liệu từ danh sách và xem chi tiết thông tin</td>
              </tr>
              <tr>
                <td className="font-bold">D</td>
                <td className="font-bold">Phân hệ Đăng nhập</td>
              </tr>
              <tr>
                <td className="font-bold">I</td>
                <td className="font-bold">Quản lý Đăng nhập</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Đăng nhập ID/Password OTP+Đăng xuất</td>
              </tr>
              <tr>
                <td />
                <td>
                  Người dùng nhập ID/pass, hệ thống kiểm tra số điện thoại thuộc
                  về người dùng nào, gửi OTP đến số điện thoại trong trường hợp
                  số điện thoại đã khai báo trong cơ sở dữ liệu. OTP có hiệu lực
                  trong n phút. Người dùng nhận đc OTP.
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Người dùng nhập OTP và xác nhận, hệ thống thông báo xác nhận
                  thành công hoặc thất bại. Hiển thị thông báo số điện thoại
                  chưa đăng ký trong trường hợp số điện thoại chưa được khai báo
                  trong cơ sở dữ liệu
                </td>
              </tr>
              <tr>
                <td />
                <td>Nhập captcha để chống spam OTP</td>
              </tr>
              <tr>
                <td />
                <td>Người dùng đăng xuất</td>
              </tr>
              <tr>
                <td>12</td>
                <td>Quản lý truy cập trên thiết bị di động (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>Xác thực bằng vân tay</td>
              </tr>
              <tr>
                <td />
                <td>Xác thực bằng Face ID</td>
              </tr>
              <tr>
                <td className="font-bold">II</td>
                <td className="font-bold">Quản lý QRcode</td>
              </tr>
              <tr>
                <td>13</td>
                <td>
                  Quản lý Qrcode cho người dùng sau khi đăng nhập (mobile app)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Người dùng bấm nút, phần mềm lấy thông tin người dùng cần
                  thiết: ID, Tên đại biểu..., khởi tạo QR code chứa các thông
                  tin và hiện QR code
                </td>
              </tr>
              <tr>
                <td className="font-bold">III</td>
                <td className="font-bold">Xem thông tin Điểm danh</td>
              </tr>
              <tr>
                <td>14</td>
                <td>Thống kê số liệu điểm danh theo phiên họp (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>
                  Lựa chọn hiển thị thống kê điểm danh theo phiên họp với các
                  tiêu chí mặc định (ngày hiện tại) hoặc các tiêu chí chọn từ
                  danh sách tiêu chí thống kê
                </td>
              </tr>
              <tr>
                <td />
                <td>Kết xuất thống kê ra word, excel, PDF</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm đại biểu có mặt, vắng mặt</td>
              </tr>
              <tr>
                <td />
                <td>Xem lý do vắng của từng đại biểu</td>
              </tr>
              <tr>
                <td />
                <td>
                  Hiển thị biểu đồ điểm danh Hội trường trực quan với các tiêu
                  chí mặc định (ngày hiện tại) hoặc các tiêu chí Chọn từ danh
                  sách tiêu chí thống kê
                </td>
              </tr>
              <tr>
                <td>15</td>
                <td>Thống kê số liệu điểm danh tại Hội trường (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>
                  Lựa chọn hiển thị thống kê điểm danh tại Hội trường với các
                  tiêu chí mặc định (ngày hiện tại) hoặc các tiêu chí chọn từ
                  danh sách tiêu chí thống kê
                </td>
              </tr>
              <tr>
                <td />
                <td>Kết xuất thống kê ra word, excel, PDF</td>
              </tr>
              <tr>
                <td />
                <td>Tìm kiếm đại biểu có mặt, vắng mặt</td>
              </tr>
              <tr>
                <td />
                <td>Xem lý do vắng của từng đại biểu</td>
              </tr>
              <tr>
                <td />
                <td>
                  Hiển thị biểu đồ điểm danh Hội trường trực quan với các tiêu
                  chí mặc định (ngày hiện tại) hoặc các tiêu chí Chọn từ danh
                  sách tiêu chí thông kê
                </td>
              </tr>
              <tr>
                <td>16</td>
                <td>Thống kê số liệu điểm danh Tổ thảo luận(mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>
                  Lựa chọn hiển thị thống kê số liệu điểm danh Tổ thảo luận với
                  các tiêu chí mặc định (ngày hiện tại) hoặc các tiêu chí từ
                  danh sách tiêu chí thống kê
                </td>
              </tr>
              <tr>
                <td />
                <td>Kết xuất thống kê ra word, excel, PDF</td>
              </tr>
              <tr>
                <td />
                <td>Xem lý do vắng của từng đại biểu</td>
              </tr>
              <tr>
                <td />
                <td>
                  Hiển thị Biểu đồ điểm danh Tổ thảo luận trực quan với các tiêu
                  chí mặc định (ngày hiện tại) hoặc các tiêu chí chọn từ danh
                  sách tiêu chí thông kê
                </td>
              </tr>
              <tr>
                <td>17</td>
                <td>
                  Lịch sử đăng nhập (của cá nhân người đăng nhập - mobile app)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách lịch sử đăng nhập theo tiêu chí mặc định
                  hoặc tiêu chí tìm kiếm (tài khoản, họ tên đại biểu, thời gian
                  đăng nhập)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn 1cá nhân từ danh sách và xem chi tiết lịch sử đăng nhập
                  cá nhân
                </td>
              </tr>
              <tr>
                <td className="font-bold">E</td>
                <td className="font-bold">Phân hệ Điều hành</td>
              </tr>
              <tr>
                <td className="font-bold">I</td>
                <td className="font-bold">Điều hành phát biểu Hội trường</td>
              </tr>
              <tr>
                <td>18</td>
                <td>Đăng ký phát biểu (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>Thêm mới/sửa/xóa Đăng ký phát biểu</td>
              </tr>
              <tr>
                <td />
                <td>Xem lại nội dung phát biểu text</td>
              </tr>
              <tr>
                <td />
                <td>Xem lại nội dung phát biểu âm thanh</td>
              </tr>
              <tr>
                <td>19</td>
                <td>Chọn lựa, sắp xếp thứ tự phát biểu (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>
                  Sắp xếp danh sách Đăng ký phát biểu theo tiêu chí mặc định
                  hoặc tiêu chí tìm kiếm (họ tên đại biểu, chủ đề phát biểu)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Chọn đăng ký phát biểu từ danh sách và xem chi tiết thông tin
                </td>
              </tr>
              <tr>
                <td />
                <td>Sắp xếp thứ tự phát biểu</td>
              </tr>
              <tr>
                <td className="font-bold">II</td>
                <td className="font-bold">Điều hành nội dung</td>
              </tr>
              <tr>
                <td>20</td>
                <td>Quản lý tiến độ thời gian</td>
              </tr>
              <tr>
                <td />
                <td>
                  Cấu hình thời gian báo cáo từ lúc bắt đầu đến lúc kết thúc
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Bấm bắt đầu để tính giờ, thông báo hiện màu đỏ khi trễ (hết
                  giờ). Hệ thống gửi thông tin tính giờ đến máy chủ và các máy
                  của Đại biểu khác để bắt đầu đồng bộ quá trình đếm. Lưu thời
                  gian vào CSDL để thống kê
                </td>
              </tr>
              <tr>
                <td>21</td>
                <td>Điều khiển màn hình Đại biểu</td>
              </tr>
              <tr>
                <td />
                <td>
                  Cho phép bật/tắt chức năng Đồng bộ màn hình của các máy khác
                  khi chuyển nội dung mới và thông báo đến các máy khác về việc
                  chuyển nội dung
                </td>
              </tr>
              <tr>
                <td className="font-bold">III</td>
                <td className="font-bold">Biểu quyết</td>
              </tr>
              <tr>
                <td>22</td>
                <td>Quản lý nội dung biểu quyết (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>Chọn biểu quyết từ danh sách và xem chi tiết thông tin</td>
              </tr>
              <tr>
                <td />
                <td>
                  Thêm mới/sửa/xóa nội dung, đổi logo, hình ảnh, tiêu đề cho
                  cuộc biểu quyết
                </td>
              </tr>
              <tr>
                <td />
                <td>Duyệt thực hiện biểu quyết</td>
              </tr>
              <tr>
                <td>23</td>
                <td>Quản lý nội dung biểu quyết (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>Chọn biểu quyết từ danh sách và xem chi tiết thông tin</td>
              </tr>
              <tr>
                <td />
                <td>Cấu hình và xem thời gian biểu quyết.</td>
              </tr>
              <tr>
                <td />
                <td>Thay đổi logo, hình ảnh, tiêu đề cho cuộc biểu quyết</td>
              </tr>
              <tr>
                <td />
                <td>Xem kết quả cuộc biểu quyết</td>
              </tr>
              <tr>
                <td>24</td>
                <td>
                  Thực hiện biểu quyết và thông báo kết quả cuộc biểu quyết
                  (mobile app)
                </td>
              </tr>
              <tr>
                <td />
                <td>Chọn, thực hiện cuộc biểu quyết từ danh sách</td>
              </tr>
              <tr>
                <td />
                <td>Xem kết quả cuộc biểu quyết</td>
              </tr>
              <tr>
                <td className="font-bold">IV</td>
                <td className="font-bold">Kênh hỗ trợ</td>
              </tr>
              <tr>
                <td>25</td>
                <td>Nhắn tin nội bộ (cá nhân, kênh nhóm) - mobile app</td>
              </tr>
              <tr>
                <td />
                <td>Gửi nhận Instant Message cho cá nhân, nhóm</td>
              </tr>
              <tr>
                <td />
                <td>Tạo, chọn kênh thông tin, kênh nhóm</td>
              </tr>
              <tr>
                <td />
                <td>Chụp hình dán vào khung chat gửi kèm Instant Message</td>
              </tr>
              <tr>
                <td />
                <td>Xem, lựa chọn icon, gõ tắt icon gửi kèm Instant Messa</td>
              </tr>
              <tr>
                <td className="font-bold">F</td>
                <td className="font-bold">Phân hệ Internet</td>
              </tr>
              <tr>
                <td className="font-bold">I</td>
                <td className="font-bold">Quản trị nội dung cơ bản</td>
              </tr>
              <tr>
                <td>26</td>
                <td>Góp ý tài liệu có giới hạn thời gian (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>Xem tài liệu họp, xem thời hạn góp ý</td>
              </tr>
              <tr>
                <td />
                <td>Thêm/sửa/xóa góp ý</td>
              </tr>
              <tr>
                <td>27</td>
                <td>
                  Cơ chế hoạt động khi di chuyển từ vùng có kết nối internet
                  sang vùng chỉ kết nối mạng nội bộ và ngược lại (mobile app)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Thiết bị di động của Đại biểu nhận biết kết nối internet. Tự
                  động kết nối, hiện các giao diện, chức năng hạn chế sau khi
                  xác thực bằng thẻ hoặc qr code. Và ngược lại ẩn các giao diện,
                  chức năng hạn chế, không lưu trữ tài liệu khi chuyển từ vùng
                  kết nối internet sang môi trường không mạng.
                </td>
              </tr>
              <tr>
                <td>28</td>
                <td>Đăng ký vắng</td>
              </tr>
              <tr>
                <td />
                <td>Đăng ký lý do vắng</td>
              </tr>
              <tr>
                <td className="font-bold">G</td>
                <td className="font-bold">Phân hệ Khác</td>
              </tr>
              <tr>
                <td className="font-bold">I</td>
                <td className="font-bold">Hệ thống</td>
              </tr>
              <tr>
                <td>29</td>
                <td>Cấu hình đăng nhập (mobile app)</td>
              </tr>
              <tr>
                <td />
                <td>Cho phép Bật/tắt đăng nhập bằng vân tay</td>
              </tr>
              <tr>
                <td />
                <td>Cho phép Bật/tắt đăng nhập bằng FaceID</td>
              </tr>
              <tr>
                <td className="font-bold">II</td>
                <td className="font-bold">Thông báo</td>
              </tr>
              <tr>
                <td>30</td>
                <td>
                  Thông báo yêu cầu tài liệu, yêu cầu hỗ trợ đã được xử lý, tin
                  nhắn mới, cuộc họp mới (mobile app)
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Người dùng gửi yêu cầu tài liệu cần xem, hệ thống gửi thông
                  báo đến người liên quan theo biểu mẫu quy định.
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Người dùng gửi yêu cầu hỗ trợ, hệ thống gửi thông báo đến
                  người liên quan theo biểu mẫu quy định
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Người dùng gửi instant message, hệ thống gửi thông báo đến
                  người liên quan theo biểu mẫu quy định
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Lựa chọn gửi thông báo cuộc họp mới đến người liên quan theo
                  biểu mẫu quy định
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  Hiện số đếm thông báo chưa đọc, người dùng đọc thông báo hệ
                  thống sẽ giảm số đếm
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
